import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';

export type Size = 'small' | 'large';

export enum SizeConverter {
  small = '2rem',
  large = '3rem',
}

@Component({
  selector: 'ls-button-icon-atom',
  standalone: true,
  imports: [ButtonModule, RippleModule, CommonModule, SkeletonModule],
  templateUrl: './button-icon-atom.component.html',
  styleUrl: './button-icon-atom.component.scss',
})
export class ButtonIconAtomComponent {
  @Input() label!: string;

  @Input() type = 'button';

  @Input() icon = 'pi';

  @Input() styleClass = '';

  @Input() disabled = false;

  @Input() rounded = false;

  @Input() loading = false;

  @Input() processing = false;

  public skeletonSize = '2.5rem';

  private _size!: Size;

  get size(): Size {
    return this._size;
  }
  @Input() set size(value: Size) {
    this.skeletonSize = SizeConverter[value];
    this._size = value;
  }

  @Input() severity?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warning'
    | 'help'
    | 'danger';

  @Output() onClick = new EventEmitter<Event>();

  handleClick(event: Event) {
    this.onClick.emit(event);
  }
}
